export const environment = {
  production: false,
  environment: 'staging' as const,
  domain: 'blog-stage.macmillan-learning.com',
  builderApiKey: 'e8cf29fa74d849dbac75da3186e4fb4f', // Replace with your actual Builder.io API key
};

